(function () {
  function isAnnouncementActive(bar) {
    if (!bar) return false;
    var style = window.getComputedStyle(bar);
    if (style.display === 'none' || style.visibility === 'hidden') return false;
    var section = bar.closest('.shopify-section');
    if (section && window.getComputedStyle(section).display === 'none') return false;
    return bar.offsetHeight > 0;
  }

  function updateAnnouncementHeight() {
    var bar = document.querySelector('.announcement-bar');
    if (!isAnnouncementActive(bar)) {
      document.documentElement.style.setProperty('--announcement-bar-height', '0px');
      return;
    }

    var rect = bar.getBoundingClientRect();
    var height = Math.max(0, Math.min(rect.bottom, bar.offsetHeight));
    document.documentElement.style.setProperty('--announcement-bar-height', height + 'px');
  }

  var scheduled = false;
  function scheduleUpdate() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(function () {
      scheduled = false;
      updateAnnouncementHeight();
    });
  }

  updateAnnouncementHeight();
  window.addEventListener('scroll', scheduleUpdate, { passive: true });
  window.addEventListener('resize', scheduleUpdate);
  window.addEventListener('orientationchange', scheduleUpdate);

  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(updateAnnouncementHeight);
  }

  new MutationObserver(scheduleUpdate).observe(document.documentElement, {
    subtree: true,
    attributes: true,
    attributeFilter: ['class', 'style', 'hidden'],
    childList: true
  });
})();
